<template>
  <div class="container">
    <card class="pd12">

      <div class="title">{{info.punishTitle}}</div>
      <div class="txt">行政处罚决定书日期：{{info.decideDate.substring(0,10) }}</div>
      <div class="txt">行政处罚执行日期：{{info.executeDate.substring(0,10)  }}</div>
      <div class="txt" v-if="info.lawenforcer!== ''">执法人员：{{info.lawenforcer }}</div>
      <div class="desc-tit">涉事原因</div>
      <div class="desc">{{info.reason}}</div>
      <div class="desc-tit">行政处罚方式</div>
      <div class="desc">{{info.punishMethod}}</div>
    </card>

  </div>
</template>
<script>
    import card from '../travelAgency/components/card'
    export default {
        components: {
            card
        },

        data () {
            return {
                info: {}
            };
        },

        computed: {},

        watch: {},

        methods: {

        },

        mounted () {},
        created () {
            let info = JSON.parse(this.$route.query.info)
            this.info.punishTitle = info.punishTitle || ''
            this.info.decideDate = info.decideDate || info.time || ''
            this.info.executeDate = info.executeDate || info.updateTime || ''
            this.info.lawenforcer = info.lawenforcer || ''
            this.info.reason = info.reason || info.punishDesc
            this.info.punishMethod = info.punishMethod || info.punishDetailType
        }
    }
</script>
<style scoped lang="less">
  .container {
    height: 100vh;
    background-color: @base-bgcolor;
    padding: 16px 12px;
    box-sizing: border-box;

    .pd12 {
      .title {
        font-size: 20px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 16px;
        line-height:28px;
      }

      .txt {

        margin-bottom: 12px;
        font-size: 14px;

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }

      .desc-tit {
        font-size: 14px;

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }

      .desc {
        margin-top: 4px;
        font-size: 14px;

        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        margin-bottom: 16px;
      }
    }
  }
</style>
